import type { PlayerCampaignDetails } from '@modules/playerCampaigns/types';

import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { type ISearchParameters, OPERATOR_SORT } from '@features/filters/types';
import { hasPartialUpdates } from '@utils/hasPartialUpdates';

interface IInitialState {
  manualBrandId: null | string;
  manualPlayerId: null | string;
  activeCampaignId: null | string;
  searchParameters: ISearchParameters;
  playerCampaignDetails: null | PlayerCampaignDetails;
}

export const initialPlayerCampaignsSearchParameters = {
  page: 1,
  size: 10,
  filters: [],
  sorts: [
    {
      order: OPERATOR_SORT.DESC,
      field: 'last_activation_date',
    },
  ],
};

const initialState: IInitialState = {
  manualBrandId: null,
  manualPlayerId: null,
  activeCampaignId: null,
  playerCampaignDetails: null,
  searchParameters: initialPlayerCampaignsSearchParameters,
};

const playerCampaignsSlice = createSlice({
  initialState,
  name: 'playerCampaignsSlice',
  reducers: {
    setManualBrandId(
      state: IInitialState,
      action: PayloadAction<IInitialState['manualBrandId']>
    ) {
      state.manualBrandId = action.payload;
    },
    setManualPlayerId(
      state: IInitialState,
      action: PayloadAction<IInitialState['manualPlayerId']>
    ) {
      state.manualPlayerId = action.payload;
    },
    setPlayerCampaignDetails(
      state: IInitialState,
      action: PayloadAction<PlayerCampaignDetails>
    ) {
      state.playerCampaignDetails = action.payload;
    },
    setActiveCampaignId(
      state: IInitialState,
      action: PayloadAction<IInitialState['activeCampaignId']>
    ) {
      state.activeCampaignId = action.payload;
    },
    setSearchParameters(
      state: IInitialState,
      action: PayloadAction<Partial<ISearchParameters>>
    ) {
      if (!hasPartialUpdates(state.searchParameters, action.payload)) {
        return;
      }

      state.searchParameters = { ...state.searchParameters, ...action.payload };
    },
  },
});

export default playerCampaignsSlice.reducer;

export const {
  setManualBrandId,
  setManualPlayerId,
  setSearchParameters,
  setActiveCampaignId,
  setPlayerCampaignDetails,
} = playerCampaignsSlice.actions;
